const locale = {
    placeholder: 'সময় নির্বাচন',
    rangePlaceholder: ['সময় শুরু', 'শেষ সময়'],
};
export default locale;
